import { FC } from "react";

import { DashboardProgress } from "@/dashboard-design-system/Progress";

export type LiveEditorProgressBarProps = {
  currentStepIndex: number;
  totalNumberOfSteps: number;
  "data-test"?: string;
};

export const LiveEditorProgressBar: FC<LiveEditorProgressBarProps> = ({
  currentStepIndex,
  totalNumberOfSteps,
  "data-test": dataTest = "form-editor-progress-bar",
}) => {
  const isValidTotal = totalNumberOfSteps > 0;
  const progressValue = isValidTotal ? ((currentStepIndex + 1) / totalNumberOfSteps) * 100 : 0;

  return (
    <DashboardProgress value={progressValue} innerEndRounded height={7} transitionSpeed={0.5} data-test={dataTest} />
  );
};
